<h2 mat-dialog-title id="medlem-anonymiser-dialog-tittel">{{ "Bekreft permanent deaktivering"|translate }}</h2>
<mat-dialog-content class="skjema e2e-kopiermøtedialog">
  <p>
    {{'Du er i ferd med å slette alle personopplysninger unntatt navn for gruppemedlemmet'|translate}}
    <span class="medlemsnavn">{{medlem.navn}}</span>
    {{'i {gruppe} i {organisasjon}'|translate: {gruppe: gruppe.tittel, organisasjon: gruppe.organisasjonsnavn} }}.
  </p>
  <p>
    {{'I henhold til personopplysningsloven Artikkel 5 pkt 1c om dataminimering, skal lagring av personopplysninger begrenses til det som er nødvendig for formålet.'|translate}}
    {{'Når lagring av kontaktopplysninger ikke lenger har et formål skal opplysningene slettes.'|translate}}
  </p>
  <inline-melding type="feil">
    {{'Merk at slettingen ikke kan angres.'}}
  </inline-melding>
  <p>{{'{navn} vil bli fjernet som standard deltaker fra møtemalen.'|translate:{navn: medlem.navn} }}</p>
  @if(harSlettbareMoeteAssosiasjoner()){
    <p>{{'{navn} vil bli fjernet fra følgende fremtidige møter:'|translate:{navn: medlem.navn} }}</p>
    <ul>
      @if(assosiasjoner().antTilknyttetFremtidigIkkelaastMoeteSomDeltaker > 0){
        <li>{{'Deltaker i {antall} møter'|translate:{antall:assosiasjoner().antTilknyttetFremtidigIkkelaastMoeteSomDeltaker} }}</li>
      }
      @if(assosiasjoner().antTilknyttetFremtidigIkkelaastProtokollSomDeltaker > 0){
        <li>{{'Signatar i {antall} protokoller'|translate:{antall:assosiasjoner().antTilknyttetFremtidigIkkelaastProtokollSomDeltaker} }}</li>
      }
      @if(assosiasjoner().antTilknyttetFremtidigIkkelaastSakSomAnsvarlig > 0){
        <li>{{'Saksansvarlig i {antall} saker'|translate:{antall:assosiasjoner().antTilknyttetFremtidigIkkelaastSakSomAnsvarlig} }}</li>
      }
    </ul>
  }
  <mat-form-field>
    <mat-label>{{ 'Angi årsak'|translate }}</mat-label>
    <input matInput [formControl]="skjema.controls.aarsak">
    @if(skjema.controls.aarsak.hasError('maxlength')){
      <mat-error data-testid="maxlength">{{skjema.controls.aarsak.errors | standardvalideringsfeil:'maxlength' }}</mat-error>
    }
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-button type="button" (click)="avbryt()">{{ "Avbryt"|translate }}</button>
  <button mat-raised-button color="primary" type="button" (click)="anonymiser()" [disabled]="lagrer() || skjema.invalid"
          [visSpinner]="lagrer()" spinnerTekst="{{'Deaktiverer...'|translate}}" class="e2e-deaktiver">
    {{ "Deaktiver permanent"|translate }}
  </button>
</mat-dialog-actions>
